import React, { createContext, useState, useEffect, useContext } from 'react';
import { jwtDecode } from 'jwt-decode'; // Correct import

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      validateToken(token);
    }
  }, []);

  const validateToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Current time in seconds
      if (decoded.exp && decoded.exp > currentTime) {
        setUser(decoded); // Token is valid
      } else {
        logout(); // Token is expired
      }
    } catch (error) {
      console.error('Error decoding token:', error.message);
      logout();
    }
  };

  const login = (token) => {
    localStorage.setItem('token', token);

    // Decode and store relevant claims
    const decoded = jwtDecode(token);
    setUser(decoded);

    // Optional: store specific claims locally
    localStorage.setItem('role_name', decoded.role_name);
    localStorage.setItem('active', decoded.active);
    localStorage.setItem('id', decoded.id);
    localStorage.setItem('customer_id', decoded.customer_id);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role_name');
    localStorage.removeItem('active');
    localStorage.removeItem('id');
    localStorage.removeItem('customer_id');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, getClaimFromUser: (claim) => user?.[claim] }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthContext;
